const selectors = {
  flashSaleParent: '.sale-timer-parent',
}

function getTimeRemaining(endtime) {
  const total = Date.parse(endtime) - Date.parse(new Date());
  const seconds = Math.floor((total / 1000) % 60);
  const minutes = Math.floor((total / 1000 / 60) % 60);
  const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
  const days = Math.floor(total / (1000 * 60 * 60 * 24));
  return {total, days, hours, minutes, seconds};
}

const initializeClock = function(el) {
  const endDate = el.dataset.timer;
  const elId = el.id
  const countDownDate = endDate.replace(/-/g, '/');
  const daysLeft = window.languages.flashDaysLeft;
  const hoursLeft = window.languages.flashHoursLeft;
  const minutesLeft = window.languages.flashMinutesLeft;
  const secondsLeft = window.languages.flashSecondsLeft;
  const clock = document.getElementById(elId);
  // If no clock, return
  if (!!!clock) {
    return
  }
  const daysSpan = clock.querySelector('.days');
  const hoursSpan = clock.querySelector('.hours');
  const minutesSpan = clock.querySelector('.minutes');
  const secondsSpan = clock.querySelector('.seconds');

  function updateClock() {
    const time = getTimeRemaining(countDownDate);
    if (daysSpan != undefined) {
      if (time.days > 0) {
        if (time.days === 1) {
          daysSpan.innerHTML = ((time.days) + ' ' + daysLeft.one);
        }else {
          daysSpan.innerHTML = ((time.days) + ' ' + daysLeft.other);
        }
        
      } else {
        daysSpan.innerHTML = ''
      }
    }
    if (hoursSpan != undefined) {
      if (time.hours < 24 && time.hours > 0 && time.days == 0) {
        if(time.hours === 1){
          hoursSpan.innerHTML = ((time.hours) + ' ' + hoursLeft.one);
        }else {
          hoursSpan.innerHTML = ((time.hours) + ' ' + hoursLeft.other);
        }
      } else {
        hoursSpan.innerHTML = '';
      }
    }
    if (minutesSpan != undefined) {
      if (time.minutes > 0 && time.minutes < 60 && time.hours < 1 && time.days == 0) {
        if (time.minutes === 1) {
          minutesSpan.innerHTML = ((time.minutes) + ' ' + minutesLeft.one);
        }else {
          minutesSpan.innerHTML = ((time.minutes) + ' ' + minutesLeft.other);
        }
      } else {
        minutesSpan.innerHTML = '';
      }
    }
    if (secondsSpan != undefined) {
      if (time.seconds > 0 && time.seconds < 60 && time.hours < 1 && time.minutes < 1 && time.days == 0) {
        if(time.seconds === 1) {
          secondsSpan.innerHTML = ((time.seconds) + ' ' + secondsLeft.one);
        }else {
          secondsSpan.innerHTML = ((time.seconds) + ' ' + secondsLeft.other);
        }
       
      } else {
        secondsSpan.innerHTML = '';
      }
    }
    // Once timer reaches 0
    if (time.total <= 0) {
      clearInterval(timeinterval);
      clock.style.display = "none";
    }
  }
  updateClock();
  const timeinterval = setInterval(updateClock, 1000);
  
}

document.addEventListener('DOMContentLoaded', function(){
  let flashSaleClocks = document.querySelectorAll(selectors.flashSaleParent);
  if (!!flashSaleClocks) {
    flashSaleClocks.forEach(el => {
      initializeClock(el)
    })
  }
});

document.addEventListener('collection:loading:end', function(){
  let flashSaleClock = document.querySelectorAll(selectors.flashSaleParent);
  if (!!flashSaleClock) {
    flashSaleClock.forEach(el => {
      initializeClock(el)
    })
  }
});